import { render, staticRenderFns } from "./CustomCheckerboard.vue?vue&type=template&id=92c07d24&v-if=isConfiguratorLoaded"
import script from "./CustomCheckerboard.vue?vue&type=script&lang=js"
export * from "./CustomCheckerboard.vue?vue&type=script&lang=js"
import style0 from "./CustomCheckerboard.vue?vue&type=style&index=0&id=92c07d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports